import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

const CssTextField = styled(TextField)({
    // Fieldset label on focus
    '& label.Mui-focused': {
        color: '#9c8c71',
    },
    
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#9c8c71',
        },

        // Fieldset box on hover
        '&:hover fieldset': {
            borderColor: '#8B7A5F',
        },

        // Fieldset box on focus
        '&.Mui-focused fieldset': {
            borderColor: '#9c8c71',
        },
    },
});

export default CssTextField;
